import React, { useState } from "react";
import { Box, Flex, VStack, HStack, Text, Input, Textarea, Button, Icon, FormControl, FormLabel, useToast } from "@chakra-ui/react";
import { FaMapMarkerAlt, /* FaPhone, */ FaEnvelope } from "react-icons/fa";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebaseConfig";
import emailjs from "@emailjs/browser";
import { auth } from "../firebaseConfig";
import { useAuthState } from "react-firebase-hooks/auth";
import LoginButton from "./LoginButton";

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });
    const toast = useToast();

    const [user, loading] = useAuthState(auth);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Viser “Du må logge inn”-melding hvis user = null
    if (!user && !loading) {
        return (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            minH="calc(100vh - 80px)"
            px={4}
          >
            <Text fontSize="xl" textAlign="center" mb={4}>
              Du må være logget inn for å sende melding
            </Text>
            <LoginButton />
          </Box>
        );
    }

    const saveToFirebase = async () => {
        try {
            await addDoc(collection(db, "contact_messages"), {
                name: formData.name,
                email: formData.email,
                message: formData.message,
                createdAt: serverTimestamp(),
            });
        } catch (error) {
            console.error("Firebase error:", error);
            throw new Error("Kunne ikke lagre melding i databasen.");
        }
    };

    const sendEmail = async () => {
        const emailParams = {
            name: formData.name,
            email: formData.email,
            message: formData.message,
        };

        try {
            // Send e-post til admin
            await emailjs.send("service_kdn7v9d", "template_siwx5p6", emailParams, "6z9QDGp_soRMgPxkH");
            // Send kopi til brukeren
            await emailjs.send("service_kdn7v9d", "template_y0gduts", emailParams, "6z9QDGp_soRMgPxkH");
        } catch (error) {
            console.error("Email.js error:", error);
            throw new Error("Kunne ikke sende e-post.");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!auth.currentUser) {
            toast({
                title: "Ikke logget inn",
                description: "Du må være logget inn for å sende melding.",
                status: "warning",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        if (!formData.name || !formData.email || !formData.message) {
            toast({
                title: "Valideringsfeil",
                description: "Alle feltene må fylles ut.",
                status: "warning",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        try {
            // Kaller begge funksjonene parallelt
            await Promise.all([saveToFirebase(), sendEmail()]);

            toast({
                title: "Suksess",
                description: "Meldingen din er sendt og lagret!",
                status: "success",
                duration: 3000,
                isClosable: true,
            });

            setFormData({ name: "", email: "", message: "" });
        } catch (error) {
            console.error("Submit error:", error);
            toast({
                title: "Feil",
                description: "Noe gikk galt! Vennligst prøv igjen senere.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    return (
        <Box maxW="900px" mx="auto" py={10} px={6} pt="100px">
            <Flex direction={{ base: "column", md: "row" }} gap={10}>
                {/* Venstre side: Kontaktinformasjon */}
                <VStack align="flex-start" flex="1" spacing={4}>
                    <Text fontSize="2xl" fontWeight="bold">
                        Ta kontakt
                    </Text>
                    <HStack>
                        <Icon as={FaMapMarkerAlt} color="gray.600" />
                        <Text fontSize="md">VANGEN WOOD</Text>
                    </HStack>
                    <HStack>
                        <Icon as={FaEnvelope} color="gray.600" />
                        <Text fontSize="md">
                            <a href="mailto:vangen.wood@gmail.com">vangen.wood@gmail.com</a>
                        </Text>
                    </HStack>
                    <Text fontSize="sm" color="gray.600">
                        Nesoddtangen
                    </Text>
                </VStack>

                {/* Høyre side: Skjema */}
                <VStack flex="1" align="flex-start" spacing={4} as="form" onSubmit={handleSubmit}>
                    <Text fontSize="2xl" fontWeight="bold">
                        Send en melding
                    </Text>
                    <Text color="gray.600">
                        Har du spørsmål, ønsker tilbud eller bare vil si hei - send meg en melding!
                    </Text>

                    <FormControl isRequired>
                        <FormLabel>Navn</FormLabel>
                        <Input name="name" value={formData.name} onChange={handleChange} border="1px solid #CBD5E0" />
                    </FormControl>

                    <FormControl isRequired>
                        <FormLabel>Epost</FormLabel>
                        <Input type="email" name="email" value={formData.email} onChange={handleChange} border="1px solid #CBD5E0" />
                    </FormControl>

                    <FormControl isRequired>
                        <FormLabel>Melding</FormLabel>
                        <Textarea name="message" value={formData.message} onChange={handleChange} border="1px solid #CBD5E0" />
                    </FormControl>

                    <Button type="submit" colorScheme="green" variant="outline" size="lg" w="full">
                        Send melding
                    </Button>
                </VStack>
            </Flex>
        </Box>
    );
};

export default ContactForm;
